import { useEffect, useRef } from 'react';

/**
 * Runs `run` now and every `ms` while enabled. A hidden tab gets no ticks and
 * catches up when it surfaces: employers park the dashboard in a background tab
 * all day, and polling it there buys reads nobody can see.
 */
export function usePolling(run: () => void, enabled: boolean, ms: number): void {
  const latest = useRef(run);
  latest.current = run;

  useEffect(() => {
    if (!enabled) return;
    const tick = () => {
      if (!document.hidden) latest.current();
    };
    tick();
    const id = setInterval(tick, ms);
    document.addEventListener('visibilitychange', tick);
    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', tick);
    };
  }, [enabled, ms]);
}
